module.exports = __webpack_public_path__ + "img/TW.dec2287f.svg";